@if (invoice) {
  <header class="flex header">
    <h2>{{ 'Invoice_Modal_Details' | translateWF: 'Invoice Details' }}</h2>
    <p-button icon="pi pi-times" (click)="onClose()" />
  </header>
  <section class="content">
    <section>
      <div class="flex flex-col gap-4">
        <div class="form-box-row">
          <label for="">{{ 'Invoices_Invoice_Number' | translateWF: 'Invoice Number' }}</label>
          <input type="text" class="w-full p-inputtext p-component" [disabled]="true" [value]="invoice.invoiceNumber" />
        </div>
        <div class="form-box-row">
          <label for="">{{ 'Purchase_Order_Status' | translateWF: 'Status' }}</label>
          <input type="text" class="w-full p-inputtext p-component" [disabled]="true" [value]="returnStatusName(invoice.status)" />
        </div>
        <div class="form-box-row">
          <label for="">{{ 'Invoice_Details_Purchase_Order' | translateWF: 'Purchase Order' }}</label>
          <input type="text" class="w-full p-inputtext p-component" [disabled]="true" [value]="purchaseOrderNumbers" />
        </div>
      </div>
    </section>
    <section>
      <div class="under__line mb-[1rem]">
        <h2>
          {{ 'Purchase_Order_Details_Items' | translateWF: 'Items' }}
        </h2>
      </div>
      <p-table [value]="rows" class="standard">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Purchase_Order_Details_Item_Code' | translateWF: 'Item Code' }}</th>
            <th>{{ 'Purchase_Order_Details_Item_Description' | translateWF: 'Item Description' }}</th>
            <th>{{ 'Purchase_Order_Details_Quantity' | translateWF: 'Quantity' }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.itemCode }}</td>
            <td>{{ row.itemDescription }}</td>
            <td>{{ row.quantity | number: '1.2-2' }} {{ uoms[row.uom] }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3">{{ 'Invoice_Modal_No_Items' | translateWF: 'No items' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </section>
    <section>
      <div class="under__line mb-[1rem]">
        <h2>
          {{ 'Purchase_Order_Details_Files' | translateWF: 'Files' }}
        </h2>
      </div>
      @for (file of invoice.files; track $index) {
        <div class="file-container">
          <div class="file-box-container">
            <div class="file-box">
              <a (click)="onFileClick(file)" class="file-name">{{ getFileName(file) }}</a>
            </div>
          </div>
        </div>
      }
    </section>
  </section>
  <footer>
    <p-button class="w-full" [label]="'Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
  </footer>
}
